var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:{
      'inv-btn submit-button': true,
      'submit-button--loading': _vm.isLoading
    },attrs:{"disabled":_vm.disabled,"type":"submit"}},[(!_vm.isLoading)?_vm._t("default"):_vm._e(),_c('img',{staticClass:"submit-button__spinner",class:{
        'submit-button__spinner--visible': _vm.isLoading
      },attrs:{"src":require("../assets/loading-spinner.svg")}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }